
import { useFetchGetByIdfactibilidadCorporativos } from "@/shared/actions/erp/factibilidad_corporativo/factibilidad_corporativo.actions";
import SaveInventarioSolicitudFactibilidadCorporativo from "../../shared/save_inventario_solicitud_factibilidad/SaveInventarioSolicitudFactibilidadCorporativo";
import { useParams } from "react-router-dom";
import { LoaderComponent } from "@/shared/components/ui";

export default function CreateInventarioSolicitudFactibilidadPage() {

  const { id } = useParams();

  if (!id) return;

  const {
    data: dataFactibilidad,
    isLoading: isLoading
  } = useFetchGetByIdfactibilidadCorporativos(id)

  console.log('datafactibilidad',dataFactibilidad)

  if (isLoading) return <LoaderComponent />

  if (!dataFactibilidad) return null;

  return (
    <SaveInventarioSolicitudFactibilidadCorporativo
      dataFactibilidad={dataFactibilidad?.data}
      aprobadoPage={dataFactibilidad?.data?.preaprobado_inventario!
        && dataFactibilidad?.data.aceptado_factibilidad!
        && dataFactibilidad?.data.aprobado_supervisor!
      }
    />
  )

}